import { useEffect, useMemo } from 'react';

const useTokenUsageSlider = ({ value, handleTokenUsageChange,subPlansTokenUsage }) => {
  const marks = useMemo(() => {
    if (!subPlansTokenUsage.length) return [];

    return subPlansTokenUsage
      .filter((plan) => plan?.swiftaskTokens[0]?.swiftaskToken != null)
      .map((plan) => ({
        value: plan.swiftaskTokens[0].swiftaskToken,
        label: plan.name,
      }));
  }, [subPlansTokenUsage]);

  const { minValue, maxValue, step } = useMemo(() => {
    if (marks.length === 0)
      return { minValue: 0, maxValue: 100000, step: 1000 };
    const values = marks.map((mark) => mark.value);
    const min = Math.min(...values);
    const max = Math.max(...values);
    const calculatedStep = Math.round(((max - min) * 0.01) / 100) * 100;
    const step = Math.max(100, calculatedStep);

    return {
      minValue: min,
      maxValue: max,
      step,
    };
  }, [marks]);
 
  useEffect(() => {
    handleTokenUsageChange(null, minValue);
  }, [minValue]);
  return {
    marks,
    minValue,
    maxValue,
    step,
    value,
  };
};

export default useTokenUsageSlider;